import React, { useContext } from 'react';
import { isNull } from 'lodash';
import PropTypes from 'prop-types';
import FiltersContext from '../FiltersContext';

const Digit = ({ value }) => {
  let digit = value.toString();
  let digitArr = [];
  for (let i = 0; i < digit.length; i++) {
    digitArr.push(digit[i]);
  }

  let digitComponent = digitArr.map((number, key) => (
    <span key={key}>
      {number}
    </span>
  ));

  return <div className="digit">{digitComponent}</div>;
};

Digit.propTypes = {
  value: PropTypes.number.isRequired,
};

const DigitsBox = () => {
  const { selectedRestaurants, data } = useContext(FiltersContext);
  return (<>
      {!isNull(selectedRestaurants) ? (<>
          <div className="d-flex align-items-center">
            <div>{Drupal.t('Selected restaurants')}:</div>
          </div>
          <div className="digit-num d-flex align-items-center justify-content-end">
            <Digit value={selectedRestaurants}/>
          </div>
        </>
      ) : (<>
          <div className="d-flex align-items-center">
            <div>{Drupal.t('Selected Restaurants')}:</div>
          </div>
          <div
            className="digit-num  d-flex align-items-center justify-content-end">
            {data.generalData.numberOfRestaurants}
          </div>
        </>
      )}</>
  );
};

export default DigitsBox;
